import { render } from "./DetailEquipageModal.vue?vue&type=template&id=5bef8e6a&ts=true"
import script from "./DetailEquipageModal.vue?vue&type=script&lang=ts"
export * from "./DetailEquipageModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__